import AccordionUI from 'marketing/ui/accordion';
import StyledSelectUI from 'app/ui/styled-select';
import videos from 'marketing/modules/videos';

$(function () {
    $('[data-testimonial-read-more]').on('click', function (e) {
        e.preventDefault();

        $(this).closest('[data-testimonial-trimmed-content]').attr('data-hidden', true);
        $(this).closest('[data-testimonial]')
            .find('[data-testimonial-full-content]')
            .removeAttr('data-hidden');
    });

    AccordionUI.attachTo('[data-accordion]');
    StyledSelectUI.attachTo('[data-styled-select]');

    videos.run();
});



// WEBPACK FOOTER //
// ./src/web/js/marketing/testimonials.js